export default __webpack_public_path__ + "static/experience_growth_tek-5fd6fe2053b797832e081bf0c4a2ad05.webp";